import { ETableStructureType } from 'ui/EasTable/types';
import { TBoxStructure } from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { TCreditNote } from 'redux/reducers/invoiceManagement/types';

export const creditNoteBoxStructure: TBoxStructure<TCreditNote> = {
	title: 'Credit Note',
	header: [],
	body: [
		{ name: 'CN Number', selector: 'number', type: ETableStructureType.STRING },
		{ name: 'CN Date', selector: 'createdAt', type: ETableStructureType.DATE_TIME },
		{ name: 'Credited Amount', selector: 'crTotalAmount', type: ETableStructureType.AMOUNT },
		{ name: 'VAT Amount', selector: 'crTotalVat', type: ETableStructureType.AMOUNT },
		{ name: 'Processing Status', selector: 'processingStatus', type: ETableStructureType.STRING },
		{ name: 'Processing Method', selector: 'processingMethod', type: ETableStructureType.STRING },
		{
			name: 'Refunded Invoice ID',
			selector: 'refundedInvoiceId',
			type: ETableStructureType.STRING,
		},
		{ name: 'Comments', selector: 'comments', type: ETableStructureType.STRING },
		{ name: 'Payment Info', selector: 'paymentInfo', type: ETableStructureType.STRING },
		{ name: 'Created By', selector: 'createdBy', type: ETableStructureType.USER },
		{ name: 'Updated At', selector: 'updatedAt', type: ETableStructureType.DATE_TIME },
		{ name: 'Updated By', selector: 'updatedBy', type: ETableStructureType.USER },
	],
};
